/**
 * "Recently viewed" items for the command palette (#150) — a small, per-browser
 * MRU list (localStorage, not synced/server-side) so the palette has something
 * useful to show before the user types a query.
 */

const KEY = 'rmdv_recent_items';
const MAX = 8;

/** @returns {Array<{id: string, display_id?: string, title: string}>} */
export function getRecentItems() {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/** Push (or move-to-front if already present) an item onto the MRU list. */
export function pushRecentItem(item) {
  if (!item || !item.id) return;
  try {
    const existing = getRecentItems().filter((r) => r.id !== item.id);
    const next = [
      { id: item.id, display_id: item.display_id, title: item.title || '' },
      ...existing,
    ].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // localStorage unavailable/full — recents are a convenience, not critical.
  }
}
